/**
 * Compact SVG payment method icons.
 * Accepts `variant` for light (footer) or dark (cart) backgrounds.
 */

interface PaymentIconsProps {
  variant?: "light" | "dark";
  className?: string;
}

const iconColor = (variant: "light" | "dark") =>
  variant === "light" ? "fill-primary-foreground/40" : "fill-muted-foreground";

const PaymentIcons = ({ variant = "light", className = "" }: PaymentIconsProps) => (
  <div className={`flex items-center gap-2 flex-wrap ${className}`}>
    {/* Visa */}
    <svg viewBox="0 0 38 24" className="h-5 w-auto" aria-label="Visa">
      <rect width="38" height="24" rx="3" className={variant === "light" ? "fill-primary-foreground/10" : "fill-border"} />
      <path d="M15.6 16.4h-2.4l1.5-9.3h2.4l-1.5 9.3zm-4.5-9.3l-2.3 6.4-.3-1.3-.8-4.2s-.1-.9-1.1-.9H3.1l-.1.3s1.2.3 2.6.9l2.2 8.1h2.5l3.8-9.3h-2.5zm17.7 9.3h2.2l-1.9-9.3h-1.9c-.8 0-1 .6-1 .6l-3.5 8.7h2.5l.5-1.4h3l.1 1.4zm-2.6-3.3l1.3-3.4.7 3.4h-2zm-4.4-3.7l.3-2s-1.1-.4-2.2-.4c-1.2 0-4 .5-4 3 0 2.3 3.2 2.3 3.2 3.5s-2.9.9-3.8.2l-.4 2.1s1.1.5 2.8.5c1.7 0 4.1-.9 4.1-3.1 0-2.3-3.2-2.5-3.2-3.5 0-1 2.2-.9 3.2-.3z" className={variant === "light" ? "fill-primary-foreground/50" : "fill-foreground/60"} />
    </svg>

    {/* Mastercard */}
    <svg viewBox="0 0 38 24" className="h-5 w-auto" aria-label="Mastercard">
      <rect width="38" height="24" rx="3" className={variant === "light" ? "fill-primary-foreground/10" : "fill-border"} />
      <circle cx="15" cy="12" r="6" className="fill-red-500/70" />
      <circle cx="23" cy="12" r="6" className="fill-amber-400/70" />
      <path d="M19 7.7a6 6 0 0 1 0 8.6 6 6 0 0 1 0-8.6z" className="fill-orange-500/70" />
    </svg>

    {/* American Express */}
    <svg viewBox="0 0 38 24" className="h-5 w-auto" aria-label="American Express">
      <rect width="38" height="24" rx="3" className={variant === "light" ? "fill-primary-foreground/10" : "fill-border"} />
      <text x="19" y="14.5" textAnchor="middle" fontSize="5.5" fontWeight="700" className={variant === "light" ? "fill-primary-foreground/50" : "fill-foreground/60"} fontFamily="system-ui">AMEX</text>
    </svg>

    {/* iDEAL */}
    <svg viewBox="0 0 38 24" className="h-5 w-auto" aria-label="iDEAL">
      <rect width="38" height="24" rx="3" className={variant === "light" ? "fill-primary-foreground/10" : "fill-border"} />
      <text x="19" y="14.5" textAnchor="middle" fontSize="7" fontWeight="600" className={variant === "light" ? "fill-primary-foreground/50" : "fill-foreground/60"} fontFamily="system-ui">iDEAL</text>
    </svg>

    {/* Apple Pay */}
    <svg viewBox="0 0 38 24" className="h-5 w-auto" aria-label="Apple Pay">
      <rect width="38" height="24" rx="3" className={variant === "light" ? "fill-primary-foreground/10" : "fill-border"} />
      <text x="19" y="14.5" textAnchor="middle" fontSize="6.5" fontWeight="500" className={variant === "light" ? "fill-primary-foreground/50" : "fill-foreground/60"} fontFamily="system-ui"> Pay</text>
    </svg>

    {/* Klarna */}
    <svg viewBox="0 0 38 24" className="h-5 w-auto" aria-label="Klarna">
      <rect width="38" height="24" rx="3" className={variant === "light" ? "fill-primary-foreground/10" : "fill-border"} />
      <text x="19" y="14.5" textAnchor="middle" fontSize="7" fontWeight="700" className={variant === "light" ? "fill-primary-foreground/50" : "fill-foreground/60"} fontFamily="system-ui">Klarna</text>
    </svg>
  </div>
);

export default PaymentIcons;
